import {
  FETCH_QUESTION_ARTICLE_CONTENT,
  FETCH_QUESTION_ARTICLE_CONTENT_SUCCESS,
  FETCH_QUESTION_ARTICLE_CONTENT_FAILED
} from "../actions/actionTypes";

const initialState = {
  isLoading: true,
  content: {},
  records: null,
  error: false
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_QUESTION_ARTICLE_CONTENT:
      return {
        ...state,
        isLoading: true,
        content: {}
      };
    case FETCH_QUESTION_ARTICLE_CONTENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        records: payload.records,
        content: payload
      };
    case FETCH_QUESTION_ARTICLE_CONTENT_FAILED:
      return {
        ...state,
        isLoading: false,
        content: {},
        error: payload
      };
    default:
      return state;
  }
}
